module.exports = __webpack_public_path__ + "img/bg.91787ca1.png";